import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth tokens live in httpOnly cookies set by the backend. We send cookies
// on every request via `withCredentials`. Nothing is stored in localStorage,
// which removes the XSS exfiltration risk previously flagged in code review.
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function requestResourceAccess(payload) {
  const { data } = await api.post("/resources/access", payload);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}

export async function getPayPalConfig() {
  const { data } = await api.get("/paypal/config");
  return data;
}

export async function createPayPalOrder(courseSlug) {
  const { data } = await api.post("/paypal/create-order", { course_slug: courseSlug });
  return data;
}

export async function capturePayPalOrder({ orderId, courseSlug, studentName, studentEmail }) {
  const { data } = await api.post("/paypal/capture-order", {
    order_id: orderId,
    course_slug: courseSlug,
    student_name: studentName || undefined,
    student_email: studentEmail || undefined,
  });
  return data;
}

// Admin
export async function adminLogin({ email, password }) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}

export async function adminLogout() {
  const { data } = await api.post("/auth/logout");
  return data;
}

export async function adminMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function adminStats() {
  const { data } = await api.get("/admin/stats");
  return data;
}

export async function adminList(kind, { limit = 50, skip = 0 } = {}) {
  const map = {
    enrollments: "/admin/enrollments",
    contacts: "/admin/contacts",
    "resource-leads": "/admin/resource-leads",
    newsletter: "/admin/newsletter",
    "store-leads": "/admin/store-leads",
  };
  const url = map[kind];
  if (!url) throw new Error(`Unknown admin list: ${kind}`);
  const { data } = await api.get(url, { params: { limit, skip } });
  return data;
}

export async function submitStoreLead(payload) {
  const { data } = await api.post("/store/lead", payload);
  return data;
}

export async function adminReplyTemplates() {
  const { data } = await api.get("/admin/reply-templates");
  return data;
}

export async function adminSendReply(contactId, { templateId, subject, body }) {
  const { data } = await api.post(`/admin/contacts/${contactId}/reply`, {
    template_id: templateId || undefined,
    subject,
    body,
  });
  return data;
}

export async function adminListReplies(contactId) {
  const { data } = await api.get(`/admin/contacts/${contactId}/replies`);
  return data;
}
